import React from 'react';
import UnifiedCommissionPanel from '../../components/Admin/UnifiedCommissionPanel';

const CommissionManagement = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6 lg:p-8">
      <div className="mx-auto max-w-7xl">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Unified Commission Management</h1>
              <p className="text-gray-600 mt-2">Manage both one-tier and two-tier commission structures with full transparency</p>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                <span>One-Tier (Admin ↔ Driver)</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                <span>Two-Tier (Admin ↔ Vendor ↔ Driver)</span>
              </div>
            </div>
          </div>
        </div>

        {/* Unified Commission Content */}
        <div className="bg-white rounded-xl shadow-md border border-gray-200">
          <div className="p-6">
            <UnifiedCommissionPanel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommissionManagement;
